import { c as _c } from "react/compiler-runtime";
import { IcoTrash16 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import type { CSSProperties, ReactNode, Ref } from 'react';
import { createInlineMarkupRegistry, EditableText, type EditableTextProps, type SubmitReason } from '@/components/block-primitives';
import CaretPlaceholder from '../caret-placeholder';
type ListRowProps = {
  autoFocus?: boolean;
  className?: string;
  editable?: boolean;
  editorRef?: EditableTextProps['ref'];
  label: string;
  leading?: ReactNode;
  marker: ReactNode;
  onAdvance?: () => void;
  onSubmit: (next: string, reason: SubmitReason) => void;
  onSubmitLines: (lines: string[], reason: SubmitReason) => void;
  onEmptyBlur: () => void;
  onRemove?: () => void;
  placeholder: string;
  ref?: Ref<HTMLLIElement>;
  removeLabel: string;
  style?: CSSProperties;
  value: string;
};
const ListRow = t0 => {
  const $ = _c(32);
  const {
    autoFocus,
    className,
    editable: t1,
    editorRef,
    label,
    leading,
    marker,
    onAdvance,
    onSubmit,
    onSubmitLines,
    onEmptyBlur,
    onRemove,
    placeholder,
    ref,
    removeLabel,
    style,
    value
  } = t0;
  const editable = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cx("group/row flex items-start gap-1", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== marker) {
    t3 = <span aria-hidden={true} className="mt-1 flex h-5 min-w-4 shrink-0 items-center justify-end">{marker}</span>;
    $[2] = marker;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = editable && "hover:bg-hover in-data-force-affordance:bg-hover";
  let t5;
  if ($[4] !== t4) {
    t5 = cx("group/field relative min-w-0 flex-1 rounded-sm transition-colors", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== autoFocus || $[7] !== editable || $[8] !== editorRef || $[9] !== label || $[10] !== onAdvance || $[11] !== onEmptyBlur || $[12] !== onSubmit || $[13] !== onSubmitLines || $[14] !== placeholder || $[15] !== value) {
    t6 = <EditableText as="div" autoFocus={autoFocus} className="min-h-7 py-1 pl-2 pr-8 text-body-2 text-primary opacity-100! before:content-none!" editable={editable} editOnFocus={true} label={label} onAdvance={onAdvance} onSubmit={onSubmit} onSubmitLines={onSubmitLines} onEmptyBlur={onEmptyBlur} optional={true} placeholder={placeholder} registry={emptyMarkup} ref={editorRef} value={value} />;
    $[6] = autoFocus;
    $[7] = editable;
    $[8] = editorRef;
    $[9] = label;
    $[10] = onAdvance;
    $[11] = onEmptyBlur;
    $[12] = onSubmit;
    $[13] = onSubmitLines;
    $[14] = placeholder;
    $[15] = value;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== onRemove || $[18] !== removeLabel) {
    t7 = onRemove && <IconButton aria-label={removeLabel} className="absolute right-1 top-px opacity-0 transition-opacity hover:bg-none! group-hover/field:opacity-70 hover:opacity-100! focus-visible:opacity-100! in-data-force-affordance:opacity-70 max-md:opacity-70" color="tertiary" icon={IcoTrash16} onClick={onRemove} size="tiny" />;
    $[17] = onRemove;
    $[18] = removeLabel;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== placeholder || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <CaretPlaceholder className={t5} overlayClassName="min-h-7 py-1 pl-2 pr-8 text-body-2 text-quaternary" text={placeholder}>{t6}{t7}</CaretPlaceholder>;
    $[20] = placeholder;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== leading || $[26] !== ref || $[27] !== style || $[28] !== t2 || $[29] !== t3 || $[30] !== t8) {
    t9 = <li className={t2} ref={ref} style={style}>{leading}{t3}{t8}</li>;
    $[25] = leading;
    $[26] = ref;
    $[27] = style;
    $[28] = t2;
    $[29] = t3;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};
const emptyMarkup = createInlineMarkupRegistry([]);
export default ListRow;